import { Box, Button, Card, Container, FormLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';

import {
  getCleanerSetting,
  createCleanerSetting,
  updateExtraCleaningSettings,
  getExtraCleaningSettings,
} from '../helper/backend_helper';
import appConfig from '../config';
import InfoTooltip from '../components/InfoTooltip';
// import logo from 'src/components/logo';

const ExtraCleaningSettings = () => {
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [paymentReminderMessage, setPaymentReminderMessage] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getExtraCleaningSettings();

      setConfirmationMessage(response.data.data.confirmationMessage);
      setPaymentReminderMessage(response.data.data.paymentReminderMessage);
    };

    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      const BannerData = {
        confirmationMessage,
        paymentReminderMessage,
      };

      console.log(BannerData);

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateExtraCleaningSettings(BannerData, Categoryheaders);
      console.log(response);
      Swal.fire({
        icon: 'success',
        title: 'Cleaner Settings updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Cleaner Settings',
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Extra Cleaning Settings </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Extra Cleaning Confirmation<InfoTooltip title="Message sent to the guest to confirm their extra cleaning request has been booked." /></FormLabel>
              <TextField
                multiline
                minRows={4}
                label="Enter Message"
                id="outlined-size-small"
                value={confirmationMessage}
                onChange={(e) => setConfirmationMessage(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Extra Cleaning Payment Reminder To Guest<InfoTooltip title="Reminder message sent to the guest prompting payment for a requested extra cleaning." /></FormLabel>
              <TextField
                multiline
                minRows={4}
                label="Enter Message"
                id="outlined-size-small"
                value={paymentReminderMessage}
                onChange={(e) => setPaymentReminderMessage(e.target.value)}
              />
            </Stack>
          </Stack>
        </Box>

        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default ExtraCleaningSettings;
